import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Layout from 'web/components/Layout';
import Button from 'web/components/Button';
import Search from 'web/components/Search';
import AlertModal from 'web/components/AlertModal';

import SearchTypeahead from 'web/components/SearchTypeahead';
import HeaderContainer from 'web/components/HeaderContainer';

import GridSection from 'web/components/GridSection';

import DropDown from 'web/components/DropDown';
import { postLoadSearch, postLoadSearchById } from 'redux/actions/postLoad';
import { postInventorySearch, postInventorySearchById } from 'redux/actions/postInventory';
import Pagination from 'web/components/Pagination';
// import Select from 'web/components/form-elements/Select';
// import heroBanner from 'web/assets/images/heroBanner.png';
// import SearchScreen from '../CommonPages/SearchPostScreen/SearchScreen';

// import card1 from 'web/assets/images/card1.';
// import card2 from 'web/assets/images/card2.png';
// import card3 from 'web/assets/images/card3.png';
// import card4 from 'web/assets/images/card4.png';
import styles from './dashboard.module.scss';

import {
    sellerDashboard,
} from 'redux/actions/dashboard';

const dropDownArr = [
    {
        id: '0',
        label: 'DropDown1',
        value: 'DropDown1',
    },
    {
        id: '1',
        label: 'DropDown2',
        value: 'DropDown2',
    },
];

const Buyer = () => {
    let history = useHistory();
    const dispatch = useDispatch();
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);
    let title = '';

    const [postModal, setPostModal] = useState(false);
    const togglePostModal = () => setPostModal(!postModal);

    const token = localStorage.getItem('token');

    const [currentPage, setCurrentPage] = useState(1);
    const TOTAL_PAGES = 28;
    
    let nearBySelectedPageObj = {
        nearBySelectedPage: 1,
      }
    dispatch({ type: 'NEARBY_PAGINATION', payload: nearBySelectedPageObj })

    //localStorage.setItem('userType', 'Buyer');

    const [options, setOptions] = useState(['this', 'little', 'piggy', 'went', 'to', 'market']);
    const [searchResponse, setSearchResponse] = useState({ payload: [], title: '', totalRecods: '' });
    const searchHandleFun = async (val, title, totalRecods) => {
        setSearchResponse({ payload: val, title: title, totalRecods: totalRecods })
    };
    const [dashbaordResponse, setDashbaordResponse] = useState([]);
    // const fetchMyAPI = async () => {
    //     if (token === null) {
    //         setModalContent('Please Sign In again.');
    //         setModalLink('/sign-in');
    //         toggleModal();
    //     } else {
    //         let response = await dispatch(sellerDashboard(token));
    //         if (response.message === "Unauthorized (Invalid token)") {
    //             history.push('/sign-in')
    //             window.location.reload(false);
    //         } else {
    //             if (response.status === "SUCCESS") {
    //                 if (response.payload) {
    //                     setDashbaordResponse(response.payload)
    //                 }
    //             } else {
    //                 if (response.message === "Unauthorized (Invalid token)") {
    //                     history.push('/sign-in')
    //                     window.location.reload(false);
    //                 } else {
    //                     setModalContent(response.message);
    //                     setModalLink('');
    //                     toggleModal();
    //                 }
    //             }
    //         }
    //     }
    // }
    useEffect(() => {
        // fetchMyAPI()
    }, []);

    const onChangeHandler = (val) => {
        searchApi(searchResponse.title, currentPage, val)
    }

    const searchApi = async (title, pageNumber, sort) => {
        let response = await dispatch(postInventorySearch(title, pageNumber, sort, token));
        if (response.status === 'SUCCESS') {
            if (response.payload && response.payload.content) {
                // const options = response.payload.content.map((i) => ({
                //     id: i.id,
                //     title: i.title,
                // }));
                setSearchResponse({ payload: response.payload.content, title: title, totalRecods: response.payload.totalElements });
            }
        }
    }
    const onPageChange = (pageNumber) => {
        setCurrentPage(pageNumber)
        searchApi(searchResponse.title, pageNumber, 'ASC')
    }
    return (
        <Layout transparentHeader={false} userType="Buyer" pageType="Dashboard" topBarViewMobile={"hide"}>
            <Helmet
                title="The Tools You Need To Efficiently Manage Your Pallet Supply | PalletTrader">
         <meta name="description"
    content="An e-commerce platform providing instant access to the largest online network of vetted pallet buyers and sellers so you can seamlessly manage your pallet supply." />           
         <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/dashboard" />
            </Helmet>
            <div className={styles.homeWrapper}>
                <HeaderContainer userType='Buyer' buttonName='Post to Marketplace' searchHandlerEvent={(val, title, totalRecods) => { searchHandleFun(val, title, totalRecods) }} />

                <div className={styles.wrapper}>
                    {searchResponse.payload.length === 0 ? (
                        <>
                            <GridSection dashbaordResponse={dashbaordResponse} />
                        </>
                    ) : ('')}
                    {searchResponse.totalRecods && <Pagination
                        currentPage={currentPage}
                        totalPage={searchResponse.totalRecods}
                        itemsCountPerPage={10}
                        onPageChange={(value) => onPageChange(value)}
                    />
                    }
                </div>
            </div>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title={title}
                content={modalContent}
                link={modalLink}
            />
        </Layout>
    );
}
export default Buyer;